import Indicador from "..";
import TCEditFields from "./components/TCEditFields";
import { TCParamFields } from "./components/TCParamFields";
import report from "./reports";
import reportSummary from "./reports/summary";

export default class TC extends Indicador {
    static get fullName() {
        return "Tonelada Colhida";
    }

    static get abbrev() {
        return "TC";
    }

    static paramFields(tipoIndicadorField = '') {
        return <TCParamFields tipoIndicadorField={tipoIndicadorField} />;
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <TCEditFields visita={visita} TipoClass={TipoClass} />;
    }

    async renderReport(visita) {
        return report(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return reportSummary(this, visita, tipoName);
    }

    static calcConformidade(apontamento, params) {
        return 0;
    }

    static getConformidadeStatus(conformidade, meta) {
        return '';
    }

    static getTableRelApontamentos(paramsCliente, IndicadorClass) {
        return [
            { title: "Data", width: 'auto', getValue: (a) => a.dataRef.split("-").reverse().join('/') },
            { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
            { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: 'auto' },
            { title: "Fazenda", field: "laudoRef.fazenda.nomeFazenda" },
            { title: "Talhão", field: "talhao.nome" },
            { title: "Frente", field: "frente", width: 'auto' },
        ];
    }

    static getResultStr(apontamento) {
        if (!apontamento.coletas) return "";
        const total = apontamento.coletas.reduce((s, c) => s + parseFloat(c.coleta || 0), 0);
        return `Total Colhido: ${total} (${apontamento.coletas.length} coletas)`;
    }
}
